import {
  AbilityBuilder,
  CreateAbility,
  createMongoAbility,
  MongoAbility,
} from '@casl/ability'
import { z } from 'zod'

import { UserInfo } from '@/common/hooks/useGetUserInfo'
import { permissions } from './permissions'
import { accountSubject } from './subjects/accountSubject'
import { applicationAccountUserSubject } from './subjects/applicationAccountUserSubject'
import { applicationsSubject } from './subjects/applicationsSubject'
import { registersSubject } from './subjects/registersSubject'
import { settingsSubject } from './subjects/settingsSubject'
import { ssoSubject } from './subjects/ssoSubject'
import { userSubject } from './subjects/userSubject'

export const appAbilities = z.union([
  userSubject,
  settingsSubject,
  applicationsSubject,
  accountSubject,
  applicationAccountUserSubject,
  ssoSubject,
  registersSubject,
  z.tuple([z.literal('manage'), z.literal('all')]),
])

type AppAbilities = z.infer<typeof appAbilities>

export type AppAbility = MongoAbility<AppAbilities>
const createAppAbility = createMongoAbility as CreateAbility<AppAbility>

export function defineAbilityFor(user: UserInfo) {
  const builder = new AbilityBuilder(createAppAbility)

  if (typeof permissions[user.userType] !== 'function') {
    throw new Error(`Permissions for userType ${user.userType} not found.`)
  }

  permissions[user.userType](user, builder)

  const ability = builder.build({
    detectSubjectType(subject) {
      return subject.__typename
    },
  })

  ability.can = ability.can.bind(ability)
  ability.cannot = ability.cannot.bind(ability)

  return ability
}
